(function () {
    'use strict';

    angular
        .module('app')
        .factory('testService', testService);

    testService.$inject = ['clientService'];

    function testService($http) {
        var service = {
            testACSError: testACSError
        };

        return service;

        function testACSError() {
            clientService.get("filesystem/error").then(function (result) {
                console.log(result);
            });
        }
    }
})();